// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"546":"css/admin-app.6697","692":"css/app.6697"}[chunkId] + ".css";
};